<template>
  <div>
    <div class="modal-content-container">
      <b-row>
        <b-col cols="12" class="mb-3">
          <ul class="e-breadcrumb">
            <li v-for="(item, i) in breadcrumb" :key="i" class="e-breadcrumb__item" :class="{'e-breadcrumb--active': item.active, 'e-breadcrumb--current': item.current}">
              <span>{{ i + 1 }}. {{ item.value }}</span>
            </li>
            <li class="e-breadcrumb__item e-create-rate__edit ml-auto">
              <b-btn class="e-create-rate__reset" variant="link" size="sm" @click="changeStep(1)">
                <i class="fas fa-pen mr-2"></i>Edit criteria
              </b-btn>
            </li>
          </ul>
        </b-col>
      </b-row>
      <em-rate-evaluation
        v-for="(criterion, i) in criteria"
        v-if="currentStep === i + 1"
        :criterionId="criterion.id"
        :key="criterion.id"
      />
      <!--<em-rate-lock-tokens-->
        <!--v-show="currentStep - criteria.length === 1"-->
        <!--:locked="lockedTokens"-->
        <!--:accept="acceptRules"-->
        <!--@changeTokensLocked="onChangeTokensLocked"-->
        <!--@changeAcceptRules="onChangeAcceptRules"-->
      <!--/>-->
      <e-lock-tokens v-show="currentStep - criteria.length === 1" v-model="lockedModel"/>

      <em-rate-finish
        v-show="currentStep - criteria.length === 2"
        :criteria="criteria"
        @editCriterion="onEditCriterion"
      />

      <transition name="fade">
        <div v-if="isFinished" class="success-message">
          <div class="img-container">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <path style="fill:#0672f3;" d="M496.396,61.776c20.807,20.807,20.807,54.664,0,75.471L248.82,384.822
                c-6.895,6.895-15.951,10.342-25.007,10.342c-9.056,0-18.112-3.447-25.007-10.342l-120.34-120.34
                c-20.807-20.807-20.807-54.664,0-75.471s54.664-20.807,75.471,0l69.876,69.862L420.925,61.776
                c10.41-10.397,24.063-15.609,37.742-15.609C472.319,46.167,485.999,51.379,496.396,61.776z M477.052,117.904
                c10.137-10.15,10.137-26.648,0-36.785c-10.137-10.137-26.648-10.137-36.785,0L241.16,280.227
                c-4.637,4.637-10.793,7.182-17.346,7.182c-6.553,0-12.708-2.544-17.332-7.182l-71.887-71.873
                c-5.075-5.075-11.724-7.606-18.386-7.606c-6.662,0-13.324,2.531-18.399,7.606c-10.137,10.137-10.137,26.634,0,36.785l120.34,120.34
                c3.119,3.119,8.208,3.119,11.327,0L477.052,117.904z"/>
              <path style="fill:#D2E3FB;" d="M477.052,81.119c10.137,10.137,10.137,26.634,0,36.785L229.477,365.479
                c-3.119,3.119-8.208,3.119-11.327,0L97.81,245.139c-10.137-10.15-10.137-26.648,0-36.785c5.075-5.075,11.737-7.606,18.399-7.606
                c6.662,0,13.31,2.531,18.386,7.606l71.887,71.873c4.624,4.637,10.78,7.182,17.332,7.182s12.708-2.544,17.346-7.182L440.268,81.119
                C450.404,70.982,466.916,70.982,477.052,81.119z"/>
              <path style="fill:#0672f3;" d="M449.72,239.845c0.383,5.308,0.575,10.739,0.575,16.156c0,124.143-100.997,225.141-225.141,225.141
                S0,380.144,0,256S101.011,30.86,225.154,30.86c49.165,0,95.867,15.568,135.046,45.006c6.046,4.542,7.264,13.119,2.722,19.152
                c-4.542,6.046-13.119,7.264-19.152,2.722c-34.418-25.855-75.43-39.521-118.617-39.521C116.086,58.219,27.359,146.946,27.359,256
                s88.727,197.781,197.795,197.781c109.055,0,197.781-88.727,197.781-197.781c0-4.761-0.178-9.535-0.506-14.186
                c-0.547-7.538,5.13-14.09,12.654-14.637C442.634,226.644,449.173,232.307,449.72,239.845z"/>
            </svg>
          </div>
          <h3>Your rate has been saved.</h3>
          <p>Soon your rate will be taken into account in the overall assessment of "{{ asset.name }}"" asset.</p>
        </div>
      </transition>
    </div>

    <div class="modal-footer">
      <e-button type="outlined" v-if="!isFinished" @click="closeModal">Cancel</e-button>
      <div class="d-flex ml-auto">
        <e-button v-if="!isFinished" @click="onPreviewClick" style="margin-right: 30px">Preview</e-button>
        <e-button v-if="!isFinished" :disabled="nextBtnDisabled" @click="onNextClick">{{ currentStep - criteria.length === 2 ? 'Submit rating' : 'Next' }}</e-button>
        <e-button v-if="isFinished" @click="closeModal">OK</e-button>        
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import EmRateEvaluation from "./evaluation";
  import EmRateFinish from "./finish";
  import Services from '../../../services';

	export default {
		name: "em-rate-step-write",
    components: {EmRateFinish, EmRateEvaluation},
    props: {
      assetId: String,
      modalId: String,
    },
    watch: {
      assetId: {
        handler(current) {
          this.asset = this.getAsset(current);
          this.changeTitle();
        },
        immediate: true,
      }
    },
    data() {
		  return {
		    currentStep: 1,
        lockedTokens: 0,
        acceptRules: false,
        isFinished: false,
        asset: null,
      }
    },
    methods: {
      ...mapActions('rate', {
        changeEvaluation: 'changeEvaluation',
      }),
      ...mapGetters('assets', {
        getCriterion: 'criterion',
      }),
      onEditCriterion(step) {
        this.currentStep = step;
      },
      changeStep(step) {
        this.$emit('changeStep', step);
      },
      async onNextClick() {
        if(this.currentStep - this.criteria.length === 2) {
          await Services.Rates.createRate({
            assetId: this.assetId,
            lockedTokens: this.lockedModel.locked,
            criteria: this.getCurrentCreateRateCriteria.map(id => {
              const criterion = this.getCriterion(id);
              const criterionId = criterion && criterion.id != null ? criterion.id : id;
              const isNew = typeof criterionId === 'string' && criterionId.indexOf('new_') === 0;

              const c = {
                evaluate: this.getCriterionEvaluation(id),
                justification: this.getCriterionJustification(id),
              };

              if(isNew) {
                c.title = criterion.title;
              } else {
                c.id = criterionId;
              }

              return c;
            })
          });

          this.isFinished = true;

          // this.$emit('closeModal');
          return;
        }

        this.currentStep++;
      },
      onPreviewClick() {
        if(this.currentStep === 1) {
          this.$emit('previewStep')
        } else {
          this.currentStep--;
        }
      },
      changeTitle() {
        this.$emit('changeTitle', `Rate ${this.asset.name}`);
      },
      closeModal() {
        this.$emit('closeModal');
      }
    },
    computed: {
      ...mapGetters('rate', [
        'getCurrentCreateRateCriteria',
        'getCriterionEvaluation',
        'getCriterionJustification',
      ]),
      ...mapGetters('assets', {
        getAsset: 'asset',
        getCriterion: 'criterion',
      }),

      lockedModel: {
        get() {
            return {
              locked: this.lockedTokens,
              rules: this.acceptRules,
              disabled: false,
            };
        },
        set(value) {
          this.lockedTokens = value.locked;
          this.acceptRules = value.rules;
        },
      },

      nextBtnDisabled() {
        if(this.currentStep <= this.criteria.length) {
          return this.getCriterionJustification(this.criteria[this.currentStep - 1].id).length === 0;
        }

        if(this.currentStep === this.criteria.length + 1) {
          return !(this.lockedTokens > 0 && this.acceptRules);
        }
      },
      criteria() {
        return this.getCurrentCreateRateCriteria.map(id => this.getCriterion(id));
      },
      breadcrumb() {
        let criteria = this.criteria;

        return criteria.map((c, i) => {
          return {
            value: c.title,
            active: this.currentStep > i + 1,
            current: this.currentStep === i + 1
          }
        }).concat([
          {
            value: 'Lock tokens',
            active: this.currentStep > criteria.length + 1,
            current: this.currentStep === criteria.length + 1,
          },
          {
            value: 'Finish',
            active: this.currentStep > criteria.length + 2,
            current: this.currentStep === criteria.length + 2
          }
        ])
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/rate/write.vue